import { useQuery } from '@tanstack/react-query';
import { nexusFetch } from '../../nexus/nexusClient';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';

/**
 * Produkt-Statistik Compliance — Betreiber-Sicht, nur lesend. Monitore
 * (gesamt/aktiv), Tenants, Runs, Durchschnitts-Score sowie die Aufschlüsselung
 * der Runs nach Verdikt. M2M-Auth wie alle /v1/admin/*-Endpoints.
 */
const FIXTURE = {
  monitors: 312,
  enabled: 287,
  tenants: 96,
  runs: 18740,
  avgScore: 91.4,
  byVerdict: [
    { verdict: 'ok', n: 16920 },
    { verdict: 'issues', n: 1820 },
  ],
};

export function useComplianceStats() {
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['product-stats-compliance', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) { await fixtureDelay(); return FIXTURE; }
      return nexusFetch('/v1/admin/product-stats/compliance');
    },
    refetchInterval: 60_000,
  });
}
